import { AfterViewInit, Directive, ElementRef, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import constants from 'src/constant.json';
declare const google:any;

@Directive({
  selector: '[googleAutocomplete]',
})
export class GoogleAutocompleteDirective implements AfterViewInit, OnDestroy {
  @Output() addressComponents = new EventEmitter();

  @Input() set googleAutocomplete(value: '(cities)' | 'geocode' | '(regions)' | '') {
    if (value) {
      this.autocompleteType = value;
    }
  }

  private autocompleteType: '(cities)' | '(regions)' | 'geocode' = 'geocode';
  private constant: any = constants;
  // private autocomplete: any;
  // private placeChangeListener: any = null;

  private autocomplete: any = null;
  private onPlaceSelect: ((event: any) => void) | null = null;
  private onInputChange: (() => void) | null = null;
  private destroyed = false;

  constructor(private element: ElementRef) {}

  // ngAfterViewInit(): void {
  //   this.autocomplete = new google.maps.places.Autocomplete(this.element.nativeElement, {
  //     componentRestrictions: { country: 'US' },
  //     types: [this.autocompleteType], // 'establishment' / 'address' / 'geocode'
  //   });
  //   this.placeChangeListener = google.maps.event.addListener(this.autocomplete, 'place_changed', () => {
  //     const place = this.autocomplete.getPlace();
  //     this.invokeEvent(place);
  //   });
  // }

  async ngAfterViewInit(): Promise<void> {
    const host: HTMLInputElement = this.element.nativeElement;
    const placesLibrary: any = await google.maps.importLibrary('places');
 
    
    if (this.destroyed || !host.parentElement) {
      return;
    }
 
    const options: any = {
      componentRestrictions: { country: 'US' },
      placeholder: host.placeholder || '',
    };
 
    // '(cities)' and '(regions)' are still valid type collections in the new
    // API. 'geocode' was legacy-only, so for it the type filter is left unset.
    if (this.autocompleteType !== 'geocode') {
      options.types = [this.autocompleteType];
    }
    const element = new placesLibrary.PlaceAutocompleteElement(options);
    element.setAttribute('no-input-icon', '');
    element.setAttribute('no-clear-button', ''); 
    element.addEventListener('focusin', () => {
      host.dispatchEvent(new FocusEvent('focus', { bubbles: true }));
    });

    element.addEventListener('focusout', () => {
      host.dispatchEvent(new FocusEvent('blur', { bubbles: true }));
    });
    this.autocomplete = element;
 
    // Insert next to the original input and hide it, rather than removing it.
    // Angular can then still tear the host down cleanly (e.g. inside *ngIf).
    host.parentElement.insertBefore(element, host.nextSibling);
    host.style.display = 'none';
 
    this.onInputChange = () => this.syncHostValue(element.value);
 
    this.onPlaceSelect = async (event: any) => {
      const place = event.placePrediction.toPlace();
      await place.fetchFields({ fields: ['formattedAddress'] });
      this.syncHostValue(place.formattedAddress);
      this.getPlaceFromGeocoder(place.formattedAddress);
    };
 
    element.addEventListener('input', this.onInputChange);
    element.addEventListener('gmp-select', this.onPlaceSelect);
  }
 
  private syncHostValue(value: string): void {
    const host: HTMLInputElement = this.element.nativeElement;
    host.value = value || '';
    host.dispatchEvent(new Event('input', { bubbles: true }));
  }

  ngOnDestroy(): void {
    // if (this.placeChangeListener) {
    //   google.maps.event.removeListener(this.placeChangeListener);
    // }
       this.destroyed = true;
 
    if (this.autocomplete) {
      if (this.onInputChange) {
        this.autocomplete.removeEventListener('input', this.onInputChange);
      }
      if (this.onPlaceSelect) {
        this.autocomplete.removeEventListener('gmp-select', this.onPlaceSelect);
      }
 
      this.autocomplete.remove(); 
      this.autocomplete = null;
    }
 
    this.onInputChange = null;
    this.onPlaceSelect = null;
  }

  invokeEvent(place: google.maps.places.PlaceResult) {
    if (place && place.address_components) {
      this.getPlaceFromGeocoder(place.formatted_address);
    } else {
      var googleAutoCompleteContainer = document.getElementsByClassName('pac-container');
      if (googleAutoCompleteContainer && googleAutoCompleteContainer[0]) {
        var firstAutoCompleteItem = googleAutoCompleteContainer[0].getElementsByClassName('pac-item');
        if (firstAutoCompleteItem && firstAutoCompleteItem[0]) {
          this.getPlaceFromGeocoder(firstAutoCompleteItem[0].textContent);
        }
      }
    }
  }

  getPlaceFromGeocoder(autoCompleteInput: string) {
    new google.maps.Geocoder().geocode({ address: autoCompleteInput }, (results, status) => {
      if (!results || !results[0]) return this.addressComponents.emit(null);

      let locality: string = null;
      let subPremise: string = null;
      let streetNumber: string = null;
      let city: string = null;
      let state: string = null;
      let zip: string = null;
      results[0].address_components.forEach((result) => {
        if (result.types[0] == 'route') {
          locality = result.short_name;
        } else if (result.types[0] == 'subpremise') {
          subPremise = result.short_name;
        } else if (result.types[0] == 'street_number') {
          streetNumber = result.short_name;
        } else if (result.types[0] == 'locality') {
          city = result.short_name;
        } else if (result.types[0] == 'administrative_area_level_1') {
          state = result.short_name;
        } else if (result.types[0] == 'postal_code') {
          zip = result.short_name;
        }
      });
      let addressObj: any = {
        StreetAddress: streetNumber && locality ? `${streetNumber} ${locality}` : null,
        City: city,
        State: state,
        PostalCode: zip,
        logInput: true,
      };
      if (subPremise) {
        let subPreFix = subPremise.toLowerCase();
        let isPrefixIncluded = this.constant.UNIT_PREFIX.some((prefix) => subPreFix.includes(prefix.toLowerCase()));
        if (isPrefixIncluded == true) {
          addressObj.StreetAddress += ' ' + subPremise;
        } else {
          addressObj.StreetAddress += ' # ' + subPremise;
        }
      }

      addressObj['fullAddress'] = results[0].formatted_address && results[0].formatted_address.replace(/, USA/i, '');
      addressObj['center'] = results[0].geometry.location;

      this.addressComponents.emit(addressObj);
    });
  }
}
